module.exports = __webpack_public_path__ + "static/assets/57e31022b2c43cee4f854d0b18dfcc86.png";